import React, {useState} from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Home from './Pages/Home';
import TrackingNumber from './Pages/TrackingNumber'
import ScrollToTop from "./components/ScrollToTop";
import Wallet from './Pages/Wallet';
import TryAndBuyReceipt from './Pages/TryAndBuyReceipt';

function App() {
  const [lang] = useState(localStorage.getItem('lang'))

  return (
    <BrowserRouter>
    <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Navigate to={lang ? `/${lang}` : '/en'} replace />} />
        <Route path="/:lang" element={<Home />} />
        <Route path="/:lang/:trackingNumber" element={<TrackingNumber />} />
        <Route path="/:lang/payments/wallet" element={<Wallet />} />
        <Route path="/:lang/try-and-buy/receipt/:trackingNumber" element={<TryAndBuyReceipt />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;
